var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dnsInfo)?_c('div',{staticClass:"gridItem"},[_c('span',[_vm._v(_vm._s(_vm.t("dnsInfo")))]),_c('span',[_vm._v(_vm._s(_vm.dnsInfo))]),_c('copy-btn',{attrs:{"text":_vm.dnsInfo}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }